import { render, staticRenderFns } from "./ProductCustomOptions.vue?vue&type=template&id=6fbed6ff&scoped=true&"
import script from "./ProductCustomOptions.vue?vue&type=script&lang=js&"
export * from "./ProductCustomOptions.vue?vue&type=script&lang=js&"
import style0 from "./ProductCustomOptions.vue?vue&type=style&index=0&id=6fbed6ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbed6ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fbed6ff')) {
      api.createRecord('6fbed6ff', component.options)
    } else {
      api.reload('6fbed6ff', component.options)
    }
    module.hot.accept("./ProductCustomOptions.vue?vue&type=template&id=6fbed6ff&scoped=true&", function () {
      api.rerender('6fbed6ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/themes/default/components/core/ProductCustomOptions.vue"
export default component.exports